import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";






const Webinar = () => {
  const location = useLocation();

  // FIX: Add a useEffect to handle scrolling to the form when the link has a hash.
  useEffect(() => {
    if (location.hash === "#webinarRegisterForm") {
      // Use a short timeout to ensure the element has been rendered to the DOM.
      const timer = setTimeout(() => {
        const formElement = document.getElementById("webinarRegisterForm");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);

      // Clean up the timer if the component unmounts.
      return () => clearTimeout(timer);
    }
  }, [location.hash]); // This effect runs whenever the URL hash changes.

  const title = "Event Details";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1,
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <>
      <Helmet>
        <title>Event Details | MSB Association</title>
        {/* For SEO, we'll strip HTML from the description */}
        <meta name="description" content="" />
        <meta property="og:title" content="Events Details | MSB Association" />
        <meta property="og:description" content="" />
        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="page_header text-center section_decoration overflow-hidden eventbg-image-css">
        <div className="container">
          <motion.h1
            className="page_title text-white"
            initial="hidden"
            animate="visible"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {title.split("").map((letter, index) => (
              <motion.span
                key={index}
                custom={index}
                variants={letterVariants}
                style={{
                  display: "inline-block",
                  marginRight: letter === " " ? "0.3rem" : "0",
                  whiteSpace: "pre",
                }}
              >
                {letter}
              </motion.span>
            ))}
          </motion.h1>
        </div>
      </section>

      <section className="contact_section section_space">
        <div className="container">
          <div className="item_details_content p-3">
            <h2 className="item_details_heading text-center">
              Webinar: Do's & Don'ts to get a bank account for your MSB business
            </h2>

            <div className="row mt-4 mb-5">
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/date.svg" alt="Date" />
                  <div className="text-white">
                    <h5 className="fw-bold mb-1 text-white">Date</h5>
                    <span>01 July 2025</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img src="assets/images/event-banner/time.svg" alt="Time" />
                  <div className="text-white">
                    <h5 className="fw-bold mb-1 text-white">Time</h5>
                    <span>01:00 PM BST</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img
                    src="assets/images/event-banner/duration.svg"
                    alt="Duration"
                  />
                  <div className="text-white">
                    <h5 className="fw-bold mb-1 text-white">Duration</h5>
                    <span>60 mins</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-12">
                <div className="event-detail-bg mb-1">
                  <img
                    src="assets/images/event-banner/speaker.svg"
                    alt="Speaker"
                  />
                  <div className="text-white">
                    <h5 className="fw-bold mb-1 text-white">Speaker</h5>
                    <span>Mr. Steve Allen</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-4 mt-4 align-items-center">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="schedule-date fw-bold fs-5">Description</div>
                <div className="schedule-card">
                  <div className="schedule-data mb-2">
                    <h5>
                      Opening a bank account for your MSB feels impossible?
                      You’re not alone.
                    </h5>
                    <p>
                      Join us for a power-packed session where{" "}
                      <strong>Steve</strong> unveils the insider do’s and don’ts
                      that can make all the difference — from red flags to green
                      lights, and everything in between.
                    </p>
                    <h5>What you'll learn</h5>
                    <ul>
                      <li>
                        A brief overview of the remittance market in the UK and
                        Europe.
                      </li>
                      <li>
                        Key challenges remittance companies face in banking.
                      </li>
                      <li>
                        Do’s and Don’ts of onboarding with banking providers.
                      </li>
                      <li>Cross-border payment challenges.</li>
                      <li>
                        The rise of stable coins and the advantage of their
                        solution.
                      </li>
                      <li>Advice for MSBs looking to scale.</li>
                    </ul>
                    <p>
                      <strong>
                        Get the clarity, confidence, and strategy your MSB needs
                        — all in one session.
                      </strong>
                    </p>
                  </div>
                </div>
              </div>

              <hr className="d-block d-sm-none" />

              <div className="col-lg-6 col-md-6 col-12">
                <img
                  src="/assets/images/event-banner/Steve-Allen.png"
                  alt="Event"
                  className="img-fluid rounded-2"
                />
              </div>
            </div>
          </div>
          {/* <RegisterForm /> */}
       
        </div>
      </section>
    </>
  );
};

export default Webinar;
